const getApply = () => {
    return `
        import CustomAutocompleteTree from '../../../Components/CustomAutocompleteTree'; //Import CustomAutocompleteTree component from your src folder

    `;
}

export default getApply;
